export const INSIGHTS_ROUTER_BASE = '/dashboard-controls/solve-insights/v0';
export const ASSIST_INSIGHTS_BASE = '/api/v1/assist-insights';
export const DEFAULT_INSIGHT_PAGE_SIZE = 100;
export const RADAR_CHART_PREVIOUS_BORDER_COLOR = '#acafcd';
export const RADAR_CHART_PREVIOUS_COLOR = '#acafcd4c';
